
import Vue from "vue";

interface FilterData {
  candidateName: string;
  experienceLevel: string;
  yearsOfExperience: number;
  skillsLevel: number;
  englishProficiency: number;
  arabicProficiency: number;
}

export default Vue.extend({
  name: "FilterDrawer",
  props: {
    value: {
      type: Boolean,
      default: false
    },
      filters: {
        type: Object as () => FilterData,
        default: () => ({
          candidateName: '',
          experienceLevel: '',
          yearsOfExperience: 3,
          skillsLevel: 60,
          englishProficiency: 60,
          arabicProficiency: 60
        })
      },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localFilters: {
        candidateName: '',
        experienceLevel: '',
        yearsOfExperience: 3,
        skillsLevel: 60,
        englishProficiency: 60,
        arabicProficiency: 60
      } as FilterData,
      experienceLevelOptions: [
        { text: 'Beginner', value: 'beginner' },
        { text: 'Intermediate', value: 'intermediate' },
        { text: 'Advanced', value: 'advanced' },
        { text: 'Expert', value: 'expert' }
      ]
    };
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit('input', value);
      }
    }
  },
  watch: {
    filters: {
      handler(newFilters: FilterData) {
        this.localFilters = { ...newFilters };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('input', false);
    },
    onDrawerChange(value: boolean) {
      this.$emit('input', value);
    },
    onFilterChange() {
      // Emit filter changes for real-time updates if needed
      this.$emit('filter-change', this.localFilters);
    },
    applyFilters() {
      this.$emit('apply-filters', this.localFilters);
    },
    clearFilters() {
      this.localFilters = {
        candidateName: '',
        experienceLevel: '',
        yearsOfExperience: 3,
        skillsLevel: 60,
        englishProficiency: 60,
        arabicProficiency: 60
      };
      this.$emit('clear-filters');
    }
  }
});
